import privateClient from "../client/publicClient";

const githubEndpoints = {
  repos: () => `repos`,
};
const githubApi = {
  repos: async () => {
    try {
      const response = await privateClient.get(githubEndpoints.repos());

      return { response };
    } catch (err) {
      return { err };
    }
  },
};

export default githubApi;
